import * as React from 'react';
import Button from '@material-ui/core/Button/Button';

const CustomButton = (props) => {
    return <Button {...props} />;
};

export { CustomButton as Button };
